import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import "../Css/faq.css";
import { Helmet } from "react-helmet-async";

interface FaqItem {
  question: string;
  answer: string;
}

const Faq: React.FC = () => {

  const { t } = useTranslation();

  const faqData: FaqItem[] = [
    {
      question: t('faq.questions.1'),
      answer: t('faq.answers.1')
    },
    {
      question: t('faq.questions.2'),
      answer: t('faq.answers.2')
    },
    {
      question: t('faq.questions.3'),
      answer: t('faq.answers.3')
    },
    {
      question: t('faq.questions.4'),
      answer: t('faq.answers.4')
    },
    {
      question: t('faq.questions.5'),
      answer: t('faq.answers.5')
    },
    {
      question: t('faq.questions.6'),
      answer: t('faq.answers.6')
    }
  ];

  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [search, setSearch] = useState("");

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const filteredFaq = faqData.filter((item) =>
    item.question.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <Helmet>
        <title>
          FAQ | Stockifly
        </title>

        <meta
          name="description"
          content="FAQ of Stockifly"
        />
      </Helmet>

      <div className="faq-container">
        <h1 className="faq-title">{t('faq.title')}</h1>

        {/* 🔍 Recherche */}
        <input
          type="text"
          placeholder={t('faq.input')}
          className="faq-search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <div className="faq-list">
          {filteredFaq.map((item, index) => (
            <div key={index} className="faq-item">
              <div className="faq-question" onClick={() => toggle(index)}>
                <span>{item.question}</span>
                <span className="faq-icon">
                  {openIndex === index ? "−" : "+"}
                </span>
              </div>

              <div
                className={`faq-answer ${openIndex === index ? "open" : ""
                  }`}
              >
                {item.answer}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Faq;